import { useState } from "react";
import { Bell, BellRing } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { pushAvailability, subscribePush } from "@/lib/push";
import { InstallSteps, pushErrorText, usePushStatus } from "./AlertsSection";

export const WatchPriceButton = ({ p }) => {
  const [status, setStatus] = usePushStatus();
  const [busy, setBusy] = useState(false);
  const [help, setHelp] = useState(false);
  const watching = (status?.product_ids || []).includes(p.id);

  const toggle = async () => {
    const avail = pushAvailability();
    if (avail === "ios-install") {
      setHelp(true);
      return;
    }
    if (avail !== "ok") {
      toast.error(pushErrorText(null));
      return;
    }
    setBusy(true);
    try {
      setStatus(await subscribePush(watching ? { unwatch_id: p.id } : { product_id: p.id }));
      toast.success(watching ? "Aviso removido" : "Combinado! Avisamos se o preço baixar.");
    } catch (e) {
      toast.error(pushErrorText(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button data-testid="watch-price-button" onClick={toggle} disabled={busy} aria-pressed={watching}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium text-zinc-300 transition-colors hover:text-white">
        {watching ? <BellRing className="h-4 w-4 text-emerald-300" /> : <Bell className="h-4 w-4" />}
        {busy ? "Aguarde…" : watching ? "Você será avisado se baixar" : "Avise-me se baixar o preço"}
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent data-testid="watch-price-help" className="w-[calc(100%-2rem)] max-w-sm rounded-[28px] border-white/10 bg-[#0d0d0f] p-6 text-white">
          <DialogTitle className="font-display text-xl font-bold text-white">Ative os alertas no iPhone</DialogTitle>
          <DialogDescription className="text-sm text-zinc-400">No iPhone, as notificações funcionam com o site na Tela de Início:</DialogDescription>
          <InstallSteps />
        </DialogContent>
      </Dialog>
    </>
  );
};
